const baseUrl = import.meta.env.VITE_APP_SERVER_URL;

const metricsBaseUrl = import.meta.env.VITE_APP_METRICS_SERVER_URL;

const proxyBaseUrl = import.meta.env.VITE_APP_PROXY_SERVER_URL;

export { baseUrl, metricsBaseUrl, proxyBaseUrl };
